// extracted by mini-css-extract-plugin
export default {"savedTAManagement":"savedTAManagement_savedTAManagement__E4duV","taDetail":"savedTAManagement_taDetail__yIWz1","outDateHint":"savedTAManagement_outDateHint__Ik5Je"};